import ReportForm from "./component";

export default ReportForm;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/ReportForm/index.ts